import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {SocketService} from "../socket/socket.service";
import EventEmitter = NodeJS.EventEmitter;

import { Subject } from 'rxjs/Subject';
import {BadgesModel} from "./badges.model";
import {NotificationsModel} from "../notifications/notifications.model";

@Injectable()
export class BadgesService implements IDataModel {

    private API_ROOT:string = '/badges';

    public badgesHash: { [channel: string] : BadgesModel } = {};

    private _notifications = new Subject<NotificationsModel>();

    public onChange = this._notifications.asObservable();

    static disabledChannels = [];

    public emitOnChange(notification: any = '') {
        this._notifications.next(notification);
    }

    public disableChannel(channel) {
        BadgesService.disabledChannels.push(channel)
    }

    public enableChannel(channel) {
        _.pull(BadgesService.disabledChannels, channel);
    }
    
    public isChannelDisabled(channel) {
        return BadgesService.disabledChannels.indexOf(channel) > -1;
    }
    
    constructor(
        private http:Http,
        public socketService: SocketService
    ) {

        this.loadBadges();

        socketService.on('notifications.create')
            .subscribe((res) => {
                if (res.badge) {
                    this.badgesHash[res.badge.channel] = res.badge;
                }
                this.emitOnChange(res);
            })
    }

    getList(filter?:IDataFilter): Observable<ListResponseModel<BadgesModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        if (filter) {
            for (let key in filter) {
                params.set(key, filter[key]);
            }
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    loadBadges() {
        this.getList()
            .subscribe((res) => {
                this.badgesHash = {};
                res.data.forEach((item) => {
                    this.badgesHash[item.channel] = item;
                });

                this.emitOnChange();
            });
    }

    getOne(id:number):Observable<ResponseModel<BadgesModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:BadgesModel): Observable<ResponseModel<BadgesModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:BadgesModel): Observable<ResponseModel<BadgesModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        for(let i in this.badgesHash) {
            if (this.badgesHash[i].id === id) delete this.badgesHash[i];
        }

        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json())
            .subscribe((res) => {
                this.emitOnChange();
            });
    }

    removeChannel(channel:string) {
        delete this.badgesHash[channel];

        return this.http.delete(`${this.API_ROOT}?channel=${channel}`).map((res) => res.json())
            .subscribe((res) => {
                // this.emitOnChange();
            });
    }

    getUnreadCount(channel:string) {
        return this.badgesHash[channel] ? this.badgesHash[channel].count : 0;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/badges/badges.service.ts